import { initHighChartsBlocks } from './utils/utils';

const initSemiconductorIndustryTextBlock = async () => {
    const setupBlock = async () => {
        const container = document.querySelector('.semiconductor_industry_text-block');
        if (!container) return;

        initHighChartsBlocks(container);
    };

    const container = document.querySelector('.semiconductor_industry_text-block');
    if (container) {
        setupBlock();
        return;
    }

    const observer = new MutationObserver((mutations, obs) => {
        if (document.querySelector('.semiconductor_industry_text-block')) {
            obs.disconnect();
            setupBlock();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
};

document.addEventListener("DOMContentLoaded", initSemiconductorIndustryTextBlock);
